import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Col, Row } from 'react-bootstrap';
import Loading from '../../../components/Loading';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import CheckboxContainer from './CheckboxContainer';
import getValidationErrors from '../../../utils/getValidationErrors';
import { useAuth } from '../../../hooks/auth';
import { IPedidoExames } from '.';
import SelectAsync from '../../../components/SelectAsync';
import TextArea from '../../../components/TextArea';

// import { Container } from './styles';
interface IFormBusca {
  exames: string;
  outros: string[];
  PedIndicacao: string;
}

interface ICreatePedidoExamesItens {
  ItmProCodigo: number;
}

interface ICreatePedidoExamesDTO {
  PedMedUsuCodigo: number;
  PedPacCodigo: number;
  PedAgeCodigo: number;
  PedCliCodigo: number;
  PedIndicacao: string;
  itens: ICreatePedidoExamesItens[];
}

type PacienteProps = {
  pacCodigo: number;
  ageCodigo: number;
  cliCodigo: number;
  grupoExame?: number;
  handleDadosSalvos(dados: IPedidoExames[]): void;
};

const PedidoExames: React.FC<PacienteProps> = ({
  pacCodigo,
  ageCodigo,
  cliCodigo,
  grupoExame,
  handleDadosSalvos,
}) => {
  const { addToast } = useToast();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const formRefBusca = useRef<FormHandles>(null);

  const handleSalvar = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});

        const cods = `${dados.outros},${dados.exames ? dados.exames : ''}`;

        if (!cods) {
          addToast({
            title: 'Nenhum exame selecionado',
            type: 'error',
            description: 'Selecione pelo menos 01 exame',
          });
          return;
        }

        const dadosExame: ICreatePedidoExamesDTO = {
          PedMedUsuCodigo: user.UsuCodigo,
          PedPacCodigo: pacCodigo,
          PedAgeCodigo: ageCodigo,
          PedCliCodigo: cliCodigo,
          PedIndicacao: dados.PedIndicacao.toUpperCase(),
          itens: cods
            .split(',')
            .filter(it => it !== '')
            .map(item => ({ ItmProCodigo: Number(item) })),
        };

        const response = await api.post<IPedidoExames[]>(
          `/pedidoexames`,
          dadosExame,
        );

        handleDadosSalvos(response.data);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        }
        const mensagem = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar dados',
          type: 'error',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      addToast,
      user.UsuCodigo,
      pacCodigo,
      ageCodigo,
      handleDadosSalvos,
      cliCodigo,
    ],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      <div className="container">
        <>
          <Row>
            <Col md={12}>
              <Form
                ref={formRefBusca}
                initialData={{ exames: '', PedIndicacao: '' }}
                onSubmit={handleSalvar}
              >
                <TextArea
                  name="PedIndicacao"
                  label="Indicação"
                  maxLength={150}
                  rows={2}
                />
                <CheckboxContainer name="exames" gexCodigo={grupoExame} />
                <SelectAsync
                  urlApi="procedimentos/combo?termoBusca="
                  name="outros"
                  label="Outros"
                  placeholder="Procurar"
                  isClearable={false}
                  handleSelectChange={handleOnChangeVazio}
                  isMulti
                  size="gr"
                />
              </Form>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex justify-content-between mt-2">
                <Button
                  type="button"
                  onClick={() => formRefBusca?.current?.submitForm()}
                  size="sm"
                  variant="success"
                >
                  {loading ? 'Carregando...' : 'Salvar dados'}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      </div>
    </>
  );
};

export default PedidoExames;
